import { gql } from "@apollo/client";

export const ADD_USER_QUERY = gql`
    mutation AddUser($fullname: String!, $email: String!, $password: String!, $canUseMagicLink: Boolean!) {
        addUser(fullname: $fullname, email: $email, password: $password, canUseMagicLink: $canUseMagicLink) {
            id
            error
            magicLinkUrl
        }
    }
`;

export const ADD_USER_TO_ORGANIZATION_QUERY = gql`
    mutation AddUserToOrganization($email: String!) {
        addUserToOrganization(email: $email) {
            id
            error
        }
    }
`;

export const VERIFY_USER_EMAIL_QUERY = gql`
    mutation verifyUserEmail($resetToken: String!) {
        verifyUserEmail(resetToken: $resetToken) {
            bearerToken
            error
        }
    }
`;

export const VERIFY_USER_TOKEN_QUERY = gql`
    mutation verifyUserToken($resetToken: String!) {
        verifyUserToken(resetToken: $resetToken) {
            bearerToken
            error
        }
    }
`;

export const CHECK_MAGIC_LINK_MUTATION = gql`
    mutation CheckMagicLink($email: String!, $magicLink: String!) {
        checkMagicLink(email: $email, magicLink: $magicLink) {
        hasValidMagicLink
        isExpired
        error
        bearerToken
        }
    }
`;

export const REGISTER_NEW_ORGANIZATIONAL_USER_QUERY = gql`
    mutation RegisterNewOrganizationalUser($resetToken: String!, $fullname: String!, $password: String!) {
        registerNewOrganizationalUser(resetToken: $resetToken, fullname: $fullname, password: $password) {
            id
            error
        }
    }
`;

export const LOGIN_USER_QUERY = gql`
    mutation LoginUser($email: String!, $password: String!) {
        loginUser(email: $email, password: $password) {
            bearerToken
            error
        }
    }
`;

export const LOGIN_WITH_GOOGLE_QUERY = gql`
    mutation LoginWithGoogle($credential: String!) {
        loginWithGoogle(credential: $credential) {
            bearerToken
            error
        }
    }
`;

export const FORGOT_PASSWORD_QUERY = gql`
    mutation ForgotPassword($email: String!) {
        forgotPassword(email: $email) {
            success
        }
    }
`;

export const UPDATE_USER_PASSWORD_QUERY = gql`
    mutation UpdateUserPassword($password: String!) {
        updateUserPassword(password: $password) {
            success
            error
        }
    }
`;

export const UPDATE_USER_FULLNAME_QUERY = gql`
    mutation UpdateUserFullName($fullname: String!) {
        updateUserFullName(fullname: $fullname) {
            success
            error
        }
    }
`;

export const CREATE_CAMPAIGN_QUERY = gql`
    mutation CreateCampaign($campaign: TrackingCampaignSubmission!) {
        createCampaign(campaign: $campaign)
    }
`;
export const UPDATE_CAMPAIGN_QUERY = gql`
    mutation UpdateCampaign($campaign: TrackingCampaignSubmission!, $campaignId: String!) {
        updateCampaign(campaign: $campaign, campaignId: $campaignId)
    }
`;
export const DELETE_CAMPAIGN_QUERY = gql`
    mutation DeleteCampaign($campaignId: String!) {
        deleteCampaign(campaignId: $campaignId)
    }
`;

export const GET_USERDATA_QUERY = gql`
    {
        userdata: getUserData {
            fullName
            email
            admin
            magicLink
        }
        organization: getOrganization {
            users{
                createdAt
            }
        }
    }
`;

export const ADMIN_CVES_QUERY = gql`
    query AdminCves {
        adminCves {
            id
            submittedAtUtc
            originalEventTimestampUtc
            status
            countsTowardCve
            countedAtUtc
            rejectionReason
            source
            externalSubmissionId
            externalConversionId
            siteName
            domain
            trackingId
            contractTierName
            campaignName
            trackingCampaignId
            trackerId
            trackerClickId
            duplicateOfEventId
        }
    }
`;

export const GET_ACCOUNT_SUMMARY_QUERY = gql`
    query AccountSummary {
        accountSummary {
            success
            organizationId
            organizationName
            organizationCreatedAt
            planName
            subscriptionStatus
            userCount
            campaignCount
            totalCves
            countedCves
            verifiedCves
            currentPeriodCountedCves
            currentPeriodVerifiedCves
            currentPeriodProcessedCves
            currentPeriodCveLimit
            contractTierName
            contractStartDate
            committedAnnualCves
            remainingCommittedCves
            ratePerCveCents
            annualMinimumFeeCents
            annualContractValueCents
            usageCostCents
            usageValueCents
            currency
            costCalculation
            error
            users {
                email
                createdAt
                fullName
                userState
                userRoles
            }
        }
    }
`;

export const GET_TRACKER_CODE_QUERY = gql`
    {
        trackerCode
    }
`;

export const GET_POSTBACK_CODE_QUERY = gql`
    {
        postbackCode {
            pagePostback
            buttonPostback
        }
    }
`;

export const MY_CAMPAIGNS_QUERY = gql`
    query MyCampaigns($createdAt: DateTime, $length: Int=-1) {
        myCampaigns(createdAt: $createdAt, length: $length) {
            campaignDatas {
                id
                campaignName
                createdAt
                platform
                clicks
                uniqueClicks
                botClicks
                duplicateConversions
                unmatchedConversions
                landingPageURL
                conversions
                campaignType
                campaignBudget
                conversionValue
                websiteDomain
                cartPageURL
                privacyPageURL
            }
            campaignCount
        }
    }
`;

export const MY_CAMPAIGNS_CLICKS_QUERY = gql`
    query MyCampaignClicks($campaignId: String!, $createdAt: DateTime) {
        myCampaignClicks(campaignId: $campaignId, createdAt: $createdAt) {
            clickDatas {
                id
                createdAt
                ip
                clickUrl
                useragent
                referer
                referrer
                isBotClick
                conversion
                country
                region
                city
            }
            clickCount
        }
    }
`;
export const MY_CAMPAIGNS_DETAILS_QUERY = gql`
    query MyCampaignDetails($campaignId: String!) {
        myCampaignDetails(campaignId: $campaignId) {
            trackingCampaignData {
                id
                campaignName
                createdAt
                platform
                clicks
                uniqueClicks
                botClicks
                duplicateConversions
                unmatchedConversions
                landingPageURL
                conversions
                desktopClicks
                conversionValue
                campaignBudget
                campaignType
            }
            clicks {
                clickDatas {
                    id
                    createdAt
                    ip
                    clickUrl
                    useragent
                    referer
                    isBotClick
                    conversion
                    country
                    region
                    city
                }
                clickCount
            },
            cves {
                id
                submittedAtUtc
                originalEventTimestampUtc
                status
                countsTowardCve
                countedAtUtc
                rejectionReason
                source
                externalSubmissionId
                externalConversionId
                trackingCampaignId
                trackerId
                trackerClickId
                duplicateOfEventId
                ip
                clickUrl
                useragent
                referer
                isBotClick
                country
                region
                city
            }
            chartDatas{
                topLocations{
                    city
                    region
                    clickCount
                    conversionCount
                }
            }
        }
    }
`;

export const MY_CAMPAIGNS_CLICK_STATS_QUERY = gql`
    query MyCampaignClickStats($campaignId: String!, $groupby: String!) {
        myCampaignClickStats(campaignId: $campaignId, groupby: $groupby) {
            groupedBy
            stats {
                position
                clickCount
            }
        }
    }
`;
export const MY_CAMPAIGNS_CONVERSION_STATS_QUERY = gql`
    query MyCampaignConversionStats($campaignId: String!, $groupby: String!) {
        myCampaignConversionStats(campaignId: $campaignId, groupby: $groupby) {
            groupedBy
            stats {
                position
                conversionCount
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_COUNTRY = gql`
    {
        click: trackerClickInsights(propertytype:"click", groupby: "country") {
            stats {
                position
                count
            }
        }
        conversion: trackerClickInsights(propertytype:"conversion", groupby: "country") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_REGION = gql`
    {
        click: trackerClickInsights(propertytype:"click", groupby: "region") {
            stats {
                position
                count
            }
        }
        conversion: trackerClickInsights(propertytype:"conversion", groupby: "region") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_CITY = gql`
    {
        conversion: trackerClickInsights(propertytype:"conversion", groupby: "city") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_REFERER = gql`
    {
        click: trackerClickInsights(propertytype:"click", groupby: "referer") {
            stats {
                position
                count
            }
        }
        conversion: trackerClickInsights(propertytype:"conversion", groupby: "referer") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_DEVICE = gql`
    {
        click: trackerClickInsights(propertytype:"click", groupby: "device") {
            stats {
                position
                count
            }
        }
        conversion: trackerClickInsights(propertytype:"conversion", groupby: "device") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_AD_TYPE = gql`
    {
        click: trackerClickInsights(propertytype:"click", groupby: "ad_type") {
            stats {
                position
                count
            }
        }
        conversion: trackerClickInsights(propertytype:"conversion", groupby: "ad_type") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_PLATFORM = gql`
    {
        click: trackerClickInsights(propertytype:"click", groupby: "platform") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_DAY_OF_THE_WEEK = gql`
    {
        conversion: trackerClickInsights(propertytype:"conversion", groupby: "day_of_the_week") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CLICK_INSIGHTS_BY_HOUR_OF_THE_DAY = gql`
    {
        conversion: trackerClickInsights(propertytype:"conversion", groupby: "hour_of_the_day") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CAMPAIGN_INSIGHTS_BY_ROI = gql`
    {
        trackerCampaignInsights(propertytype:"roi", groupby: "roi") {
            stats {
                position
                count
            }
        }
    }
`;
export const TRACKER_CAMPAIGN_INSIGHTS_BY_AD_TYPE = gql`
    {
        trackerCampaignInsights(propertytype:"roi", groupby: "ad_type") {
            stats {
                position
                count
            }
        }
    }
`;
export const CANCEL_SUBSCRIPTION_QUERY = gql`
    mutation CancelSubscription {
        cancelSubscription {
            success
            error
        }
    }
`;
export const GET_CURRENT_SUBSCRIPTION_QUERY = gql`
  query {
    getCurrentSubscription {
      planKey
      planName
      status
    }
  }
`;
